export default "__VITE_ASSET__B3iCX4YS__"